import {Group} from 'three';
import TWEEN from '@tweenjs/tween.js';
import CubeBox from './CubeBox';
import CylinderBox from './CylinderBox';
import ExpressBox from './ExpressBox';
import MagicCubeBox from './MagicCubeBox';
import PhotoBox from './PhotoBox';
import PhotoSchedule from '../util/PhotoSchedule';
import {animateFrame} from '../util/TweenUtil';
import {disposeObject} from '../util/Resources';
const types = [CubeBox, CylinderBox, ExpressBox, MagicCubeBox];
// Magic cube: 25% -> 15% (40% less); distribute the rest evenly over ordinary types.
export function platformType(random = Math.random) {
  const draw = random();
  return draw < .15 ? MagicCubeBox : types[Math.min(2, Math.floor((draw - .15) / .85 * 3))];
}
export default class BoxGroup {
  constructor() { this.last = null; this.group = new Group(); this.boxes = []; this.photoSchedule = new PhotoSchedule(); }
  createBox() {
    const Type = this.boxes.length < 2 ? CubeBox : platformType();
    const photoIndex = this.photoSchedule.next();
    const box = photoIndex === null ? new Type(this.last) : new PhotoBox(this.last, photoIndex);
    this.group.add(box.mesh); this.boxes.push(box); this.last = box;
    if (this.boxes.length > 8) {
      const old = this.boxes.shift();
      if (old.next) old.next.prev = null;
      old.next = null;
      disposeObject(old.mesh);
    }
    return box;
  }
  updatePosition({duration = 420, onComplete = () => {}}) {
    const current = this.last.prev;
    const centerX = (this.last.position.x + current.position.x) / 2;
    const centerZ = (this.last.position.z + current.position.z) / 2;
    const move = (dx, dz) => {
      this.boxes.forEach(box => box.updateXZPosition({x: box.position.x - dx, z: box.position.z - dz}));
      this.littleMan.body.position.x -= dx; this.littleMan.body.position.z -= dz;
    };
    if (!duration) { move(centerX, centerZ); onComplete(); return; }
    let previousX = 0, previousZ = 0;
    new TWEEN.Tween({x: 0, z: 0}).to({x: centerX, z: centerZ}, duration)
      .easing(TWEEN.Easing.Cubic.InOut)
      .onUpdate(({x, z}) => { move(x - previousX, z - previousZ); previousX = x; previousZ = z; })
      .onComplete(onComplete).start();
    animateFrame();
  }
  enterStage(stage) { stage.scene.add(this.group); }
  setLittleMan(littleMan) { this.littleMan = littleMan; }
  dispose() { disposeObject(this.group); this.boxes = []; this.last = null; }
}
